import api from './api';

export const adminService = {
  // User Management
  getUsers: async () => {
    const response = await api.get('/admin/users');
    return response.data;
  },
  updateUserStatus: async (userId: number) => {
    const response = await api.post('/admin/update-user-status', { userId });
    return response.data;
  },
  toggleAga: async (userId: number) => {
    const response = await api.post('/admin/toggle-aga', { userId });
    return response.data;
  },
  deleteUser: async (userId: number) => {
    const response = await api.post('/admin/delete-user', { userId });
    return response.data;
  },
  verifyUser: async (userId: number) => {
    const response = await api.post('/admin/verify-user', { userId });
    return response.data;
  },
  getUserPassword: async (userId: number) => {
    const response = await api.get(`/admin/user-password/${userId}`);
    return response.data;
  },

  // KYC Management
  getKYCPending: async () => {
    const response = await api.get('/admin/kyc-pending');
    return response.data;
  },
  getKycUser: async (userId: number) => {
    const response = await api.get(`/admin/kyc/${userId}`);
    return response.data;
  },
  approveKyc: async (userId: number) => {
    const response = await api.post('/admin/kyc-approve', { userId });
    return response.data;
  },
  rejectKyc: async (userId: number, reason: string) => {
    const response = await api.post('/admin/kyc-reject', { userId, reason });
    return response.data;
  },

  // Withdrawal Management
  getWithdrawals: async () => {
    const response = await api.get('/admin/withdrawals');
    return response.data;
  },
  approveWithdraw: async (wdrId: number) => {
    const response = await api.post('/admin/approve-withdraw', { wdrId });
    return response.data;
  },
  rejectWithdraw: async (wdrId: number, reason: string) => {
    const response = await api.post('/admin/reject-withdraw', { wdrId, reason });
    return response.data;
  },

  // BTC Address Management
  getBtcAddress: async () => {
    const response = await api.get('/admin/btc-address');
    return response.data;
  },
  updateBtcAddress: async (address: string) => {
    const response = await api.post('/admin/update-btc-address', { btcAddress: address });
    return response.data;
  },

  // Trading Management
  getTradings: async () => {
    const response = await api.get('/admin/tradings');
    return response.data;
  },
  addTrading: async (payload: any) => {
    const response = await api.post('/admin/add-trading', payload);
    return response.data;
  },
  deleteTrading: async (tdId: number) => {
    const response = await api.post('/admin/delete-trading', { tdId });
    return response.data;
  }
};